import { ErrorTitles } from './ErrorDictionary'

enum ImportErrorCode {
  NO_REQUIRED_VALUES,
  ERROR_FORMAT,
  NO_RELATED_ENTITY,
  NO_ID_COLUMN,
  NO_FILE_READED
}
class ErrorImport extends Error {
  code: ImportErrorCode
  advices?: string[]

  /**
   * Constructor for an error during the import file action
   *
   * @param code indicates the tried action
   * @param name error
   * @param message describes the possible error cause
   * @param advices list of advices to resolve the error
   * @param params other values from Error class
   */
  constructor (code: ImportErrorCode, name: string, message: string, advices?: string[], ...params: any[]) {
    super(...params)
    this.name = name
    this.message = message
    this.advices = advices
    this.code = code
  }

  static getErrorRequiredValues (advices?: string[]) {
    return new ErrorImport(ImportErrorCode.NO_REQUIRED_VALUES, ErrorTitles.no_required_values, 'Uno o varios de los registros que se intentan crear/actualizar no cuentan con todos los valores requeridos.', advices)
  }

  static getErrorFormatValues (formatErrors: string[], recordName: string) {
    return new ErrorImport(ImportErrorCode.ERROR_FORMAT, ErrorTitles.no_format_values, `Los valores: ${formatErrors.join(', ')} no tienen un formato válido. ${recordName}`)
  }

  static getIDColumnError (advices?: string[]) {
    return new ErrorImport(ImportErrorCode.NO_ID_COLUMN, ErrorTitles.column_not_found, 'La columna "id" que indica el registro a actualizar no se encuentra en el formato', advices)
  }

  toString () {
    return `${this.name} - ${this.message} - ${this.advices && this.advices.length > 0 ? this.advices.join(', ') : ''}`
  }
}

enum HTTPStatus {
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBBIDEN = 403,
  NOT_FOUND = 404,
  NOT_ALLOWED = 405,
  NOT_ACCEPTABLE = 406,
  UNSUPPOERTED = 415,
  SERVER_ERROR = 500,
  SERVICE_UNAVAILABLE = 503
}

class HTTPError {
  message: string
  status: HTTPStatus
}

class BLUEError {
  description: string
  code: number

  constructor (code: number, description: string) {
    this.code = code
    this.description = description
  }
}

class APIErrorFormat extends Error {
  message: string
  description: string
  httpErrorResponse: any
  httpError: HTTPError | undefined
  errors: BLUEError[] = []

  constructor (message?: string, description?: string, httpErrorResponse?: any, httpError?: HTTPError, errorList?: BLUEError[], ...params: any[]) {
    super(...params)
    this.message = message || ''
    this.description = description || ''
    this.httpErrorResponse = httpErrorResponse
    this.httpError = httpError
    this.errors = errorList || []
  }

  /**
   * @returns true if has the old error format, false otherwise
   */
  isOldErrorFormat (): boolean {
    return this.message.length > 0 &&
      this.httpErrorResponse !== undefined &&
      this.description.length > 0 &&
      !this.httpError &&
      !this.errors.length
  }
  /**
   * @returns true if has the new error format, false otherwise
   */
  isNewErrorFormat (): boolean {
    return this.message.length > 0 &&
      this.httpError !== undefined &&
      this.errors &&
      this.errors.length > 0 &&
      !this.httpErrorResponse &&
      !this.description
  }
  toString () {
    if (this.isOldErrorFormat()) {
      return `Message: ${this.message},
        Description: ${this.description},
        HTTPResponse: ${this.httpErrorResponse}`
    } else if (this.isNewErrorFormat()) {
      let errors = ''
      this.errors.forEach(e => {
        errors += `{Code: ${e.code}, Description: ${e.description}}`
      })
      return `Message: ${this.message},
        HTTPError: {
          Message: ${this.httpError!.message},
          Status: ${this.httpError!.status} },
        Errors: ${errors}`
    }
  }

  static getInstance (error: any): APIErrorFormat {
    return Object.assign(new APIErrorFormat(), error)
  }
}

export { ErrorImport }
export { ImportErrorCode, APIErrorFormat, BLUEError }
